import { isWeb } from 'tamagui'
import { useThemeParams } from './useThemeParams'
import { isAdminViewRoute } from '@utils/routes'

const LOGIN_PATH = '/users/sign_in'

export function useHandleWebHomeToRedirect() {
  const { data: schoolParams } = useThemeParams()
  const isActiveHomepage = schoolParams?.school?.publishedHomepage

  // A vitrine é o destino certo para o ALUNO sem sessão: ele é um visitante da
  // loja e a home pública é o que faz sentido mostrar. O produtor no preview
  // não — sem sessão em /admin_view ele precisa da tela de login, que é o que o
  // legado faz (authenticate_user! do TMSController). Mandar para /p/home
  // esconde a falha de sessão e ainda tira o produtor da visão de admin.
  if (isWeb && isAdminViewRoute(window.location.pathname)) return LOGIN_PATH

  return isActiveHomepage ? '/p/home' : LOGIN_PATH
}
